(()=>{
  'use strict';
  const header=document.querySelector('[data-amc-catalog-heading]');
  if(!header)return;
  const main=document.getElementById('MainContent');
  const normalize=s=>s.replace(/\s+/g,' ').trim().toLowerCase();
  const titles=new Set([header.dataset.rawTitle,header.querySelector('h1')?.textContent].filter(Boolean).map(normalize));
  function reconcile(){
    main.querySelectorAll('h1,.collection__heading').forEach(node=>{
      if(header.contains(node)||node.closest('[role="dialog"],dialog,.rte,.product__description'))return;
      if(titles.has(normalize(node.textContent))||node.matches('.b-main-title,.collection__heading')){
        node.classList.add('amc-catalog-legacy-title');
        node.setAttribute('aria-hidden','true');
      }
    });
  }
  reconcile();
  let timer;
  new MutationObserver(records=>{
    if(!records.some(r=>r.addedNodes.length))return;
    clearTimeout(timer);timer=setTimeout(reconcile,80);
  }).observe(main,{childList:true,subtree:true});
})();
